export const balancesKeys = {
  me: () => ['balances', 'me'] as const,
}
